import type { SxProps, Theme } from "@mui/material";
import type { FC } from "react";
import { ThemedSvg } from "../../components/UIToolkit/ThemedSvg";
import type { NurseTrainingStatus } from "../../utils/models";
import { NurseAgencyIndicator } from "../NurseAgencyIndicator/NurseAgencyIndicator";
import { NurseUnionIndicator } from "../NurseUnionIndicator/NurseUnionIndicator";
import { TrainingStatusIndicator } from "../TrainingStatusIndicator/TrainingStatusIndicator";

const TRAINING_ICON_SX: SxProps<Theme> = { width: 12, height: 12 };

type NurseStatusIconsProps = {
	nurseId: number;
	charge?: boolean;
	trainingStatus?: NurseTrainingStatus;
};

export const NurseStatusIcons: FC<NurseStatusIconsProps> = ({ nurseId, charge, trainingStatus }) => (
	<>
		<NurseUnionIndicator nurseIdOrNurseObject={nurseId} />
		<NurseAgencyIndicator nurseId={nurseId} />
		{charge && <ThemedSvg src="/charge.svg" alt="charge" size={16} color="var(--inhouse-primary)" />}
		<TrainingStatusIndicator trainingStatus={trainingStatus} sx={TRAINING_ICON_SX} />
	</>
);
